import { render, staticRenderFns } from "./sdpl.vue?vue&type=template&id=649dd4cc&scoped=true"
import script from "./sdpl.vue?vue&type=script&lang=js"
export * from "./sdpl.vue?vue&type=script&lang=js"
import style0 from "./sdpl.vue?vue&type=style&index=0&id=649dd4cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649dd4cc",
  null
  
)

export default component.exports